module.exports = __webpack_public_path__ + "images/load-more-arrowecf9ef9c4c4d132b54b8478e34350654.svg";